import { all, takeLatest, put, call } from 'redux-saga/effects';
import memberDatabase from '../../services/member';
import teamDatabase from '../../services/team';
import { memberActionTypes } from './Member.actionTypes';
import moment from 'moment';
import { orderBy } from 'lodash';
import {
  addNotification,
  notificationStates,
} from '../../components/Notification';
import { months } from '../../utils/calenderUtils';

function* setTimeLogDayRangeSaga({ payload }) {
  console.log('payload in SET_TIMELOG_DAY_RANGE member', payload);
  yield put({
    type: memberActionTypes.SET_STATE,
    payload: {
      timelogDayRange: payload.days,
      ...payload,
    },
  });
}

function* getDateRangeDataSaga({ payload }) {
  yield put({
    type: memberActionTypes.SET_STATE,
    payload: {
      timelogDayRange: payload.days,
      selectMember: payload?.selectMember ? payload?.selectMember : false,
      memberLoading: true,
      memberTimeData: {},
    },
  });

  let dateRangeData;
  dateRangeData = yield call(
    memberDatabase.getDateRangeTimeDataMember,
    moment(payload?.start, 'DD-MM-YYYY').format('YYYY-MM-DD'),
    moment(payload?.end, 'DD-MM-YYYY').format('YYYY-MM-DD'),
    payload?.id,
    payload?.userId
  );
  yield put({
    type: memberActionTypes.SET_STATE,
    payload: {
      memberLoading: false,
      all: true,
      memberTimeData: dateRangeData.data,
      // activeUserID: payload?.activeUserID,
      topProjects: dateRangeData?.data ? dateRangeData?.data?.topProjects : [],
      topData: dateRangeData?.data ? dateRangeData?.data?.topData : {},
    },
  });
}

// GET_PROJECT_TIMELOG_DATA
function* getProjectTimeLogDataSaga({ payload }) {
  if (payload?.team?.data?.length > 0) {
    // Project data for current day or yesterday
    if (payload?.day === 0 || payload?.day === 1) {
      let idleHours = 0;
      let idleMinutes = 0;
      let taskHours = 0;
      let taskMinutes = 0;
      let productiveHours = 0;
      let productiveMinutes = 0;
      let timeDataArray = [];
      let list = [];
      let filteredList = [];
      const date = moment().subtract(payload.day, 'days').format('D:M:YYYY');
      for (let i = 0; i < payload?.team?.data?.length; i++) {
        const timeData = yield call(
          memberDatabase.getMemberTimes,
          payload?.team?.data[i]?.activeTeamid,
          payload?.userId,
          date
        );
        timeDataArray.push(timeData);
      }
      for (let j = 0; j < timeDataArray?.length; j++) {
        if (timeDataArray[j]?.success) {
          if (timeDataArray[j]?.data?.timelogs) {
            Object.entries(timeDataArray[j]?.data?.timelogs).map((res) => {
              list.push(res[1]);
            });
          }
          if (list.length > 0) {
            filteredList = list?.filter(
              (x) => x?.projectId === payload?.projectId
            );
            if (filteredList.length > 0) {
              filteredList.map((r) => {
                idleHours += r?.idleHours ? r?.idleHours : 0;
                idleMinutes += r.idleMinutes;
                taskHours += r.taskHours;
                taskMinutes += r.taskMinutes;
                if (taskMinutes > 59) {
                  taskMinutes = 0;
                  taskHours += 1;
                }
                if (idleMinutes > 59) {
                  idleMinutes = 0;
                  idleHours += 1;
                }
              });
            }
          }
        }
      }
      const newTimeData = {
        idleHours: idleHours,
        idleMinutes: idleMinutes,
        totalHours: taskHours,
        totalMinutes: taskMinutes,
        productiveHours: productiveHours,
        productiveMinutes: productiveMinutes,
      };

      if (newTimeData) {
        yield put({
          type: memberActionTypes.SET_STATE,
          payload: {
            timeData: newTimeData,
            loading: false,
          },
        });
      } else {
        const data = {
          idleHours: 0,
          idleMinutes: 0,
          totalHours: 0,
          totalMinutes: 0,
          productiveHours: 0,
          productiveMinutes: 0,
        };
        yield put({
          type: memberActionTypes.SET_STATE,
          payload: {
            timeData: data,
            loading: false,
          },
        });
      }
    }

    // Data for last 7 days and last 30 days
    if (payload?.day === 7 || payload?.day === 30) {
      let d = payload?.day;
      let time7Days = [];
      let productiveHours = 0;
      let productiveMinutes = 0;
      let idleHours = 0;
      let idleMinutes = 0;
      let taskHours = 0;
      let taskMinutes = 0;
      let newTimeData = {};
      let list = [];
      let date;

      for (d; d >= 1; --d) {
        date = moment().subtract(d, 'days').format('D:M:YYYY');
        for (let i = 0; i < payload?.team?.data?.length; i++) {
          time7Days.push(
            yield call(
              memberDatabase.getMemberTimes,
              payload?.team?.data[i]?.activeTeamid,
              payload?.userId,
              date
            )
          );
        }
      }

      time7Days.forEach((day) => {
        if (day.success) {
          if (day?.data?.timelogs) {
            Object.entries(day?.data?.timelogs).map((res) => {
              list.push(res[1]);
            });
          }
        }
      });
      if (list.length > 0) {
        const filteredList = list?.filter(
          (x) => x?.projectId === payload?.projectId
        );
        if (filteredList.length > 0) {
          filteredList.map((r) => {
            idleHours += r?.idleHours ? r?.idleHours : 0;
            idleMinutes += r.idleMinutes;
            taskHours += r.taskHours;
            taskMinutes += r.taskMinutes;
            if (taskMinutes > 59) {
              taskMinutes = 0;
              taskHours += 1;
            }
            if (idleMinutes > 59) {
              idleMinutes = 0;
              idleHours += 1;
            }
          });
        }
      }
      newTimeData = {
        idleHours: idleHours,
        idleMinutes: idleMinutes,
        totalHours: taskHours,
        totalMinutes: taskMinutes,
        productiveHours: productiveHours,
        productiveMinutes: productiveMinutes,
      };

      if (newTimeData) {
        yield put({
          type: memberActionTypes.SET_STATE,
          payload: {
            timeData: newTimeData,
            loading: false,
          },
        });
      } else {
        const data = {
          idleHours: 0,
          idleMinutes: 0,
          totalHours: 0,
          totalMinutes: 0,
          productiveHours: 0,
          productiveMinutes: 0,
        };
        yield put({
          type: memberActionTypes.SET_STATE,
          payload: {
            timeData: data,
            loading: false,
          },
        });
      }
    }

    // Data for dates between start and end date
    if (payload?.day === null) {
      let time7Days = [];
      let taskHours = 0;
      let taskMinutes = 0;
      let productiveHours = 0;
      let productiveMinutes = 0;
      let idleHours = 0;
      let idleMinutes = 0;
      let newTimeData = {};
      const s = moment(payload?.start, 'DD-MM-YYYY').format('MM/DD/YYYY');
      const e = moment(payload?.end, 'DD-MM-YYYY').format('MM/DD/YYYY');
      const startT = new Date(s);
      const endT = new Date(e);
      const date = new Date(startT.getTime());
      const dates = [];
      let list = [];
      while (date <= endT) {
        dates.push(moment(new Date(date)).format('D:M:YYYY'));
        date.setDate(date.getDate() + 1);
      }
      for (let d = 0; d < dates.length; d++) {
        for (let i = 0; i < payload?.team?.data?.length; i++) {
          time7Days.push(
            yield call(
              memberDatabase.getMemberTimes,
              payload?.team?.data[i]?.activeTeamid,
              payload?.userId,
              dates[d]
            )
          );
        }
      }

      time7Days.forEach((day) => {
        if (day.success) {
          if (day?.data?.timelogs) {
            Object.entries(day?.data?.timelogs).map((res) => {
              list.push(res[1]);
            });
          }
        }
      });
      if (list.length > 0) {
        const filteredList = list?.filter(
          (x) => x?.projectId === payload?.projectId
        );
        if (filteredList.length > 0) {
          filteredList.map((r) => {
            idleHours += r?.idleHours ? r?.idleHours : 0;
            idleMinutes += r.idleMinutes;
            taskHours += r.taskHours;
            taskMinutes += r.taskMinutes;
            if (taskMinutes > 59) {
              taskMinutes = 0;
              taskHours += 1;
            }
            if (idleMinutes > 59) {
              idleMinutes = 0;
              idleHours += 1;
            }
          });
        }
      }
      newTimeData = {
        idleHours: idleHours,
        idleMinutes: idleMinutes,
        totalHours: taskHours,
        totalMinutes: taskMinutes,
        productiveHours: productiveHours,
        productiveMinutes: productiveMinutes,
      };
      if (newTimeData) {
        yield put({
          type: memberActionTypes.SET_STATE,
          payload: {
            timeData: newTimeData,
            loading: false,
          },
        });
      } else {
        const data = {
          idleHours: 0,
          idleMinutes: 0,
          totalHours: 0,
          totalMinutes: 0,
          productiveHours: 0,
          productiveMinutes: 0,
        };
        yield put({
          type: memberActionTypes.SET_STATE,
          payload: {
            timeData: data,
            loading: false,
          },
        });
      }
    }
  } else {
    const data = {
      idleHours: 0,
      idleMinutes: 0,
      totalHours: 0,
      totalMinutes: 0,
      productiveHours: 0,
      productiveMinutes: 0,
    };
    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        timeData: data,
        loading: false,
      },
    });
  }
}

// GET_USER_TIMELOG_DATA
function* getUserTimeLogDataSaga({ payload }) {
  console.log('payload in GET_USER_TIMELOG_DATA', payload);
  yield put({
    type: memberActionTypes.SET_STATE,
    payload: {
      selectedTeamID: payload?.selectedTeamID,
      activeUserID: payload?.activeUserID,
      activeUserName: payload.activeUserName,
      days: payload?.day,
      selectedProjectId: payload?.projectId,
      loading: true,
    },
  });

  if (payload?.day === null) {
    let time7Days = [];
    let totalHours = 0;
    let totalMinutes = 0;
    let taskHours = 0;
    let taskMinutes = 0;
    let productiveHours = 0;
    let productiveMinutes = 0;
    let idleHours = 0;
    let idleMinutes = 0;
    let newTimeData = {};
    const s = moment(payload?.start, 'DD-MM-YYYY').format('MM/DD/YYYY');
    const e = moment(payload?.end, 'DD-MM-YYYY').format('MM/DD/YYYY');
    const startT = new Date(s);
    const endT = new Date(e);
    const date = new Date(startT.getTime());
    const dates = [];
    let rawData = [];
    let newList = [];
    let list = [];
    while (date <= endT) {
      dates.push(moment(new Date(date)).format('D:M:YYYY'));
      date.setDate(date.getDate() + 1);
    }
    for (let d = 0; d < dates.length; d++) {
      time7Days.push(
        yield call(
          memberDatabase.getMemberTimes,
          payload?.selectedTeamID,
          payload?.activeUserID,
          dates[d]
        )
      );
    }
    if (payload?.projectId) {
      time7Days.forEach((day) => {
        if (day.success) {
          if (day?.data?.timelogs) {
            Object.entries(day?.data?.timelogs).map((res) => {
              list.push(res[1]);
            });
          }
        }
      });
      if (list.length > 0) {
        const filteredList = list?.filter(
          (x) => x?.projectId === payload?.projectId
        );
        if (filteredList.length > 0) {
          filteredList.map((r) => {
            idleHours += r?.idleHours ? r?.idleHours : 0;
            idleMinutes += r.idleMinutes;
            taskHours += r.taskHours;
            taskMinutes += r.taskMinutes;
            if (taskMinutes > 59) {
              taskMinutes = 0;
              taskHours += 1;
            }
            if (idleMinutes > 59) {
              idleMinutes = 0;
              idleHours += 1;
            }
          });
        }
      }
      newTimeData = {
        idleHours: idleHours,
        idleMinutes: idleMinutes,
        totalHours: taskHours,
        totalMinutes: taskMinutes,
        productiveHours: productiveHours,
        productiveMinutes: productiveMinutes,
      };
    } else {
      time7Days.forEach((day) => {
        if (day.success) {
          totalHours += day.data.totalHours;
          totalMinutes += day.data.totalMinutes;
          productiveHours += day.data.productiveHours;
          productiveMinutes += day.data.productiveMinutes;
          idleHours += day.data.idleHours;
          idleMinutes += day.data.idleMinutes;
        }
      });
      newTimeData = {
        idleHours: idleHours,
        idleMinutes: idleMinutes,
        totalHours: totalHours,
        totalMinutes: totalMinutes,
        productiveHours: productiveHours,
        productiveMinutes: productiveMinutes,
      };
      //getTopProjects
      time7Days.forEach((day) => {
        if (day?.success) {
          if (day?.data?.timelogs !== undefined) {
            const arr = Object.entries(day?.data?.timelogs);
            if (arr?.length > 0) {
              for (let i = 0; i < arr?.length; i++) {
                newList.push(arr[i][1]);
              }
            }
          }
        }
      });

      if (newList?.length > 0) {
        for (let i = 0; i < newList?.length; i++) {
          yield call(
            teamDatabase.getTopProjects,
            newList[i]?.projectId,
            rawData,
            newList[i]
          );
        }
      }
    }
    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        timeData: newTimeData,
        loading: false,
        topProjects11: rawData,
      },
    });
  } else {
    if (payload?.day === 0 || payload?.day === 1) {
      let idleHours = 0;
      let idleMinutes = 0;
      let taskHours = 0;
      let taskMinutes = 0;
      let productiveHours = 0;
      let productiveMinutes = 0;
      let newTimeData = {};
      const date = moment().subtract(payload.day, 'days').format('D:M:YYYY');
      const timeData = yield call(
        memberDatabase.getMemberTimes,
        payload?.selectedTeamID,
        payload?.activeUserID,
        date
      );
      if (timeData.success) {
        if (payload?.projectId) {
          let list = [];
          if (timeData?.data?.timelogs) {
            Object.entries(timeData?.data?.timelogs).map((res) => {
              list.push(res[1]);
            });
          }
          if (list.length > 0) {
            const filteredList = list?.filter(
              (x) => x?.projectId === payload?.projectId
            );
            if (filteredList.length > 0) {
              filteredList.map((r) => {
                idleHours += r?.idleHours ? r?.idleHours : 0;
                idleMinutes += r.idleMinutes;
                taskHours += r.taskHours;
                taskMinutes += r.taskMinutes;
                if (taskMinutes > 59) {
                  taskMinutes = 0;
                  taskHours += 1;
                }
                if (idleMinutes > 59) {
                  idleMinutes = 0;
                  idleHours += 1;
                }
              });
            }
          }
        }
        const newTimeData = {
          idleHours: idleHours,
          idleMinutes: idleMinutes,
          totalHours: taskHours,
          totalMinutes: taskMinutes,
          productiveHours: productiveHours,
          productiveMinutes: productiveMinutes,
        };

        //getTopProjects
        let rawData = [];
        let ids = [];
        if (timeData?.data?.timelogs !== undefined) {
          const arr = Object.entries(timeData?.data?.timelogs);
          if (arr?.length > 0) {
            for (let i = 0; i < arr?.length; i++) {
              ids.push(arr[i][1].projectId);
              yield call(
                teamDatabase.getTopProjects,
                arr[i][1]?.projectId,
                rawData,
                arr[i][1]
              );
            }
          }
        }
        yield put({
          type: memberActionTypes.SET_STATE,
          payload: {
            timeData: payload?.projectId ? newTimeData : timeData.data,
            loading: false,
            topProjects11: rawData,
          },
        });
      } else {
        const data = {
          idleHours: 0,
          idleMinutes: 0,
          totalHours: 0,
          totalMinutes: 0,
          productiveHours: 0,
          productiveMinutes: 0,
        };
        yield put({
          type: memberActionTypes.SET_STATE,
          payload: {
            timeData: data,
            loading: false,
          },
        });
      }
    }
    if (payload?.day === 7 || payload?.day === 30) {
      let d = payload?.day;
      let time7Days = [];
      let totalHours = 0;
      let totalMinutes = 0;
      let productiveHours = 0;
      let productiveMinutes = 0;
      let idleHours = 0;
      let idleMinutes = 0;
      let taskHours = 0;
      let taskMinutes = 0;
      let newTimeData = {};
      let list = [];
      let date;

      for (d; d >= 1; --d) {
        date = moment().subtract(d, 'days').format('D:M:YYYY');
        time7Days.push(
          yield call(
            memberDatabase.getMemberTimes,
            payload?.selectedTeamID,
            payload?.activeUserID,
            date
          )
        );
      }
      if (payload?.projectId) {
        time7Days.forEach((day) => {
          if (day.success) {
            if (day?.data?.timelogs) {
              Object.entries(day?.data?.timelogs).map((res) => {
                list.push(res[1]);
              });
            }
          }
        });
        if (list.length > 0) {
          const filteredList = list?.filter(
            (x) => x?.projectId === payload?.projectId
          );
          if (filteredList.length > 0) {
            filteredList.map((r) => {
              idleHours += r?.idleHours ? r?.idleHours : 0;
              idleMinutes += r.idleMinutes;
              taskHours += r.taskHours;
              taskMinutes += r.taskMinutes;
              if (taskMinutes > 59) {
                taskMinutes = 0;
                taskHours += 1;
              }
              if (idleMinutes > 59) {
                idleMinutes = 0;
                idleHours += 1;
              }
            });
          }
        }
        newTimeData = {
          idleHours: idleHours,
          idleMinutes: idleMinutes,
          totalHours: taskHours,
          totalMinutes: taskMinutes,
          productiveHours: productiveHours,
          productiveMinutes: productiveMinutes,
        };
      } else {
        time7Days.forEach((day) => {
          if (day.success) {
            totalHours += day.data.totalHours;
            totalMinutes += day.data.totalMinutes;
            productiveHours += day.data.productiveHours;
            productiveMinutes += day.data.productiveMinutes;
            idleHours += day.data.idleHours;
            idleMinutes += day.data.idleMinutes;
          }
        });
        newTimeData = {
          idleHours: idleHours,
          idleMinutes: idleMinutes,
          totalHours: totalHours,
          totalMinutes: totalMinutes,
          productiveHours: productiveHours,
          productiveMinutes: productiveMinutes,
        };
      }
      //getTopProjects
      let rawData = [];
      let newList = [];
      time7Days.forEach((day) => {
        if (day?.success) {
          if (day?.data?.timelogs !== undefined) {
            const arr = Object.entries(day?.data?.timelogs);
            if (arr?.length > 0) {
              for (let i = 0; i < arr?.length; i++) {
                newList.push(arr[i][1]);
              }
            }
          }
        }
      });
      if (newList?.length > 0) {
        for (let i = 0; i < newList?.length; i++) {
          yield call(
            teamDatabase.getTopProjects,
            newList[i]?.projectId,
            rawData,
            newList[i]
          );
        }
      }

      yield put({
        type: memberActionTypes.SET_STATE,
        payload: {
          timeData: newTimeData,
          topProjects11: rawData,
          loading: false,
        },
      });
    }
  }
}

//GET_ALL_MEMBER_ATTENDANCE_DATA
//  function* GET_ALL_MEMBER_ATTENDANCE_DATA({ payload }) {
//   const { startDate, endDate = startDate } = payload;
//   yield put({
//     type: "member/SET_STATE",
//     payload: {
//       memberLoading: true,
//       allMemberData: [],
//     },
//   });

//   const yearIds = (() => {
//     let result = [];
//     let currentYear = startDate.getFullYear();
//     let currentMonth = startDate.getMonth();

//     while (currentYear < endDate.getFullYear()
//     || (currentYear === endDate.getFullYear()
//     && currentMonth <= endDate.getMonth())) {
//       result.push(`${months[currentMonth]}-${currentYear}`);
//       currentMonth++;
//       if (currentMonth === 12) {
//         currentMonth = 0;
//         currentYear++;
//       }
//     };
//     return result;
//   })();

//   const response = yield call(
//     memberDatabase.getAllMemberData,
//     payload?.teamId,
//     payload?.activeTeamMembers,
//     yearIds,
//     payload?.startDate,
//     payload?.endDate
//   );
//   console.log(response.data , "----=-=--=-=-=");

//   if (response?.success) {
//     yield put({
//       type: "member/SET_STATE",
//       payload: {
//         memberLoading: false,
//         allMemberData: response.data?.allData,
//         allTimeZoneMemberData: response.data?.allTimeZoneData
//       },
//     });
//   }
// }

function* getAllMemberAttendanceDataSaga({ payload }) {
  const { startDate, endDate } = payload;
  yield put({
    type: memberActionTypes.SET_STATE,
    payload: {
      isMemberTeamLoading: true,
      allMemberData: [],
    },
  });

  try {
    const response = yield call(
      memberDatabase.getMergedAttendanceExcel,
      payload?.teamId,
      startDate,
      endDate
    );

    if (response?.success) {
      // Download the file using saveAs
      const { saveAs } = require('file-saver');
      saveAs(response.data.blob, response.data.fileName);

      yield put({
        type: memberActionTypes.SET_STATE,
        payload: {
          isMemberTeamLoading: false,
          allMemberData: response.data,
          downloadComplete: true, // Signal to UI that download is complete
        },
      });

      // Show success notification
      addNotification({
        message: `Successfully downloaded attendance data`,
        level: notificationStates.success,
      });
    } else {
      yield put({
        type: memberActionTypes.SET_STATE,
        payload: {
          isMemberTeamLoading: false,
          allMemberData: [],
          downloadComplete: true, // Signal to UI that download is complete
        },
      });

      addNotification({
        message: response.error || 'Failed to download attendance data',
        level: notificationStates.error,
      });
    }
  } catch (error) {
    console.error('Error in GET_ALL_MEMBER_ATTENDANCE_DATA:', error);

    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        isMemberTeamLoading: false,
        allMemberData: [],
        downloadComplete: true, // Signal to UI that download is complete
      },
    });

    addNotification({
      message: error.message || 'Error downloading attendance data',
      level: notificationStates.error,
    });
  }
}

function* getAllMemberTimeLogSaga({ payload }) {
  yield put({
    type: memberActionTypes.SET_STATE,
    payload: {
      isMemberTeamLoading: true,
      allMemberData: [],
      allMemberTimeLogData: [],
    },
  });
  // API call to get time log data
  const response = yield call(
    teamDatabase.getAllTeamTimeLog,
    payload.user.activeTeamId,
    payload?.startDate,
    payload?.endDate
  );

  if (response?.success) {
    const { data } = response;
    // const { startDate, endDate } = payload;
    // Parse the startDate and endDate into moment objects for easy comparison
    // const start = moment(startDate, "DD/MM/YYYY");
    // const end = moment(endDate, "DD/MM/YYYY");
    // // Filter the data based on the memberId and date range
    // const filteredData = data?.filter((member) => {
    //   const currentDate = moment(member?.["date"], "DD/MM/YYYY"); // Assuming your date format is DD/MM/YYYY
    //   if (currentDate.isBetween(start, end, null, "[]")) {
    //     return member;
    //   }
    // });
    // console.log(filteredData, data, "filteredData");
    // Update the Redux state with the filtered data
    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        isMemberTeamLoading: false,
        allMemberTimeLogData: data,
      },
    });
  } else {
    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        isMemberTeamLoading: false,
        allMemberTimeLogData: [], // Clear data if the response was not successful
      },
    });
  }
}

function* getUserWeekDataSaga({ payload }) {
  yield put({
    type: memberActionTypes.SET_STATE,
    payload: {
      selectedTeamID: payload?.selectedTeamID,
      activeUserID: payload?.activeUserID,
      week: payload?.week,
    },
  });

  const weekData = yield call(
    memberDatabase.getMemberWeekTimes,
    payload?.selectedTeamID,
    payload?.activeUserID,
    payload?.week
  );

  if (weekData.success) {
    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        weekData: weekData.data,
      },
    });
  } else {
    const data = {
      idleHours: 0,
      idleMinutes: 0,
      totalHours: 0,
      totalMinutes: 0,
      productiveHours: 0,
      productiveMinutes: 0,
    };
    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        weekData: data,
      },
    });
  }
}

function* getUserTableDataSaga({ payload }) {
  yield put({
    type: memberActionTypes.SET_STATE,
    payload: {
      selectedTeamID: payload?.selectedTeamID,
      activeUserID: payload?.activeUserID,
      loading: true,
    },
  });
  let d = 6;
  const dates = [];
  for (d; d >= 0; --d) {
    dates.push(moment().subtract(d, 'days').format('D:M:YYYY'));
  }

  const tableData = yield all(
    dates.map((date) =>
      call(
        memberDatabase.getMemberTableData,
        payload?.selectedTeamID,
        payload?.activeUserID,
        date
      )
    )
  );

  yield put({
    type: memberActionTypes.SET_STATE,
    payload: {
      tableData: tableData,
      loading: false,
    },
  });
}
function* getMemberTimeLogSaga({ payload }) {
  yield put({
    type: memberActionTypes.SET_STATE,
    payload: {
      memberLoading: true,
      memberLogs: [],
      activeUserID: payload?.activeUserID,
      memberTimeData: {},
      days: payload?.days,
      timelogDayRange: payload.days,
      selectMember: payload?.selectMember ? payload?.selectMember : false,
    },
  });
  // const response = yield call(teamDatabase.getAllTeamTimeLog, payload.teamId);
  let memberResponse = {};
  if (payload?.days === 0 || payload?.days === 1) {
    const date = moment().subtract(payload?.days, 'days').format('D:M:YYYY');
    memberResponse = yield call(
      memberDatabase.getMemberTimeData,
      payload?.teamId,
      payload?.activeUserID,
      date
    );
    console.log('memberData : ', memberResponse);
  }

  if (payload?.days === 7) {
    // Get week range
    var currentDate = new Date();
    var firstday = new Date(
      currentDate.setDate(currentDate.getDate() - currentDate.getDay())
    );
    var lastday = new Date(
      currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6)
    );

    var d = new Date(firstday);
    var dateF = [
      ('0' + d.getDate()).slice(-2),
      ('0' + (d.getMonth() + 1)).slice(-2),
      d.getFullYear(),
    ].join('-');

    var d2 = new Date(lastday);
    var dateL = [
      ('0' + d2.getDate()).slice(-2),
      ('0' + (d2.getMonth() + 1)).slice(-2),
      d2.getFullYear(),
    ].join('-');

    let docId = `${dateF} to ${dateL}`;
    memberResponse = yield call(
      memberDatabase.getMemberWeekTimeData,
      payload?.teamId,
      payload?.activeUserID,
      docId
    );
    console.log('memberData : ', memberResponse);
  }

  if (payload?.days === 30) {
    const localDate = new Date();
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    let currentMonth = months[localDate.getMonth()];
    let year = localDate.getFullYear();
    let yearId = `${currentMonth}-${year}`;
    memberResponse = yield call(
      memberDatabase.getMemberMonthTimeData,
      payload?.teamId,
      payload?.activeUserID,
      yearId
    );
    console.log('memberData : ', memberResponse);
  }

  if (memberResponse) {
    // const sortData = orderBy(
    //   response.data,
    //   [
    //     function (value) {
    //       return moment(value.date, "D:M:YYYY");
    //     },
    //   ],
    //   ["desc"]
    // );

    // console.log(sortData, "sortData");
    let form = payload.start;
    let until = payload.end;

    if (payload.days !== null) {
      form = moment().subtract(payload.days, 'days');
      until = payload.days === 1 ? moment().subtract(1, 'days') : moment();
    }

    // const week = [];
    // const month = [];

    // const memberLogs = sortData.filter((day) => {
    //   const date = day.date.split(":").join("-");

    //   if (moment(date, "D-M-YYYY").isSame(new Date(), "week")) {
    //     week.push(day);
    //   }
    //   if (moment(date, "D-M-YYYY").isSame(new Date(), "month")) {
    //     month.push(day);
    //   }

    //   const isBetween = moment(date, "D-M-YYYY").isBetween(
    //     moment(form, "DD-MM-YYYY"),
    //     moment(until, "DD-MM-YYYY"),
    //     "day",
    //     "[]"
    //   );
    //   return isBetween;
    // });
    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        memberLoading: false,
        // memberLogs: {
        //   calendar: sortData,
        //   selected: memberLogs,
        //   weekLogs: week,
        //   monthLogs: month,
        // },
        all: true,
        memberTimeData: memberResponse?.data,
        activeUserID: payload?.activeUserID,
        topProjects: memberResponse?.data
          ? memberResponse?.data?.topProjects
          : [],
        topData: memberResponse?.data ? memberResponse?.data?.topData : {},
        untrackedUsers: memberResponse?.data
          ? memberResponse?.data?.untrackedUsers
          : {},
      },
    });
  } else {
    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        memberLoading: false,
      },
    });
    addNotification({
      message: 'Something went wrong. please try again!',
      level: notificationStates.error,
    });
  }
}

function* getTeamTimeLogDataSaga({ payload }) {
  const { startDate, endDate } = payload;

  // Format dates to DD/MM/YYYY format
  const formattedStartDate = moment(startDate).format('DD/MM/YYYY');
  const formattedEndDate = moment(endDate).format('DD/MM/YYYY');

  yield put({
    type: memberActionTypes.SET_STATE,
    payload: {
      isMemberTeamLoading: true,
      teamTimeLogData: [],
    },
  });

  try {
    const response = yield call(
      teamDatabase.getTeamTimelogData,
      payload?.teamId,
      formattedStartDate,
      formattedEndDate
    );

    if (response?.success) {
      // Download the file using saveAs
      const { saveAs } = require('file-saver');
      saveAs(response.data.blob, response.data.fileName);

      yield put({
        type: memberActionTypes.SET_STATE,
        payload: {
          isMemberTeamLoading: false,
          teamTimeLogData: response.data,
          downloadComplete: true, // Signal to UI that download is complete
        },
      });

      // Show success notification
      addNotification({
        message: `Successfully downloaded timelog data`,
        level: notificationStates.success,
      });
    } else {
      yield put({
        type: memberActionTypes.SET_STATE,
        payload: {
          isMemberTeamLoading: false,
          teamTimeLogData: [],
          downloadComplete: true, // Signal to UI that download is complete
        },
      });

      addNotification({
        message: response.error || 'Failed to download timelog data',
        level: notificationStates.error,
      });
    }
  } catch (error) {
    console.error('Error in GET_TEAM_TIMELOG_DATA:', error);

    yield put({
      type: memberActionTypes.SET_STATE,
      payload: {
        isMemberTeamLoading: false,
        teamTimeLogData: [],
        downloadComplete: true, // Signal to UI that download is complete
      },
    });

    addNotification({
      message: error.message || 'Error downloading timelog data',
      level: notificationStates.error,
    });
  }
}

export default function* memberWatcher() {
  yield all([
    takeLatest(memberActionTypes.GET_USER_TIMELOG_DATA, getUserTimeLogDataSaga),
    takeLatest(
      memberActionTypes.GET_ALL_MEMBER_ATTENDANCE_DATA,
      getAllMemberAttendanceDataSaga
    ),
    takeLatest(
      memberActionTypes.GET_ALL_MEMBER_TIME_LOG,
      getAllMemberTimeLogSaga
    ),
    takeLatest(memberActionTypes.GET_USER_WEEK_DATA, getUserWeekDataSaga),
    takeLatest(memberActionTypes.GET_USER_TABLE_DATA, getUserTableDataSaga),
    takeLatest(
      memberActionTypes.GET_PROJECT_TIMELOG_DATA,
      getProjectTimeLogDataSaga
    ),
    takeLatest(memberActionTypes.GET_MEMBER_TIMELOG, getMemberTimeLogSaga),
    takeLatest(memberActionTypes.SET_TIMELOG_DAY_RANGE, setTimeLogDayRangeSaga),
    takeLatest(memberActionTypes.GET_DATE_RANGE_DATA, getDateRangeDataSaga),
    takeLatest(memberActionTypes.GET_TEAM_TIMELOG_DATA, getTeamTimeLogDataSaga),
  ]);
}
